module.exports = __webpack_public_path__ + "img/new_team_ribbon.72950af8.svg";